<template>
  <div :class="[columnWidthClass, 'col-mg-12']">
    <div class="teaser">
      <img
      :src="require(`@/assets/images/article/${article.image}`)"
      class="rounded img-fluid" />
    </div>
    <h2><span class="capital">{{ article.caption.substring(0,1) }}</span>{{ article.caption.substring(1) }}</h2>
    <p v-html="introHtml"></p>
  </div>
</template>

<script>
import { renderBasicMarkdown } from "@/utils/markdown";

export default {
  name: "ArticleComponent",
  data() {
    return {}
  },
  props: {
    article: {
      type: Object,
      default() {
        return {
          caption: "Empty Caption",
          intro: "This could be your into text",
          image: "bauen.jpg",
          width: 1
        }
      }
    }
  },
  computed: {
    columnWidthClass() {
      const widthMap = {
        1: "col-lg-4",
        2: "col-lg-8",
        3: "col-lg-12"
      };
      return widthMap[this.article.width] || widthMap[1];
    },
    introHtml() {
      return renderBasicMarkdown(this.article.intro || "");
    }
  }
}
</script>

<style scoped></style>
